// @mui
import { Box, Typography, Paper, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// components
import Iconify from '../../components/Iconify';
import DIOText from '../../components/DIOText';

const ACCORDIONS = (theme) => ([
  {
    id: 1,
    value: "acc-1",
    heading: "'크루'는 어떻게 검증하여 선발하나요?",
    detail: <Typography><DIOText /> 크루는 지원자의 이력서를 보고 1차로 선발 후, 심층 인터뷰를 거쳐 최종 선발합니다.</Typography>
  },
  {
    id: 2,
    value: "acc-2",
    heading: "매칭 프로세스가 어떻게 되나요?",
    detail: <Typography>필요하신 포지션을 등록하시면 <DIOText /> 팀에서 검토 후 피드백을 드리거나 매칭을 진행합니다. <DIOText /> 매니저가 최대 세명의 후보 크루 프로필을 전달 드리고, 이중 회사에서 선택한 크루와 사전 미팅을 진행한 후, 4주 단위의 계약을 하게 됩니다.</Typography>
  },
  {
    id: 3,
    value: "acc-3",
    heading: "입금은 어떻게 하나요?",
    detail: <Typography><DIOText />가 회사에게 돈을 받아 크루에게 지급합니다(회사 -&gt; <DIOText /> -&gt; 크루). 월 단위로 세금계산서를 발행해드리면, <DIOText /> 계좌로 입금하여 주시면 됩니다. 부가세 별도입니다.</Typography>
  },
  {
    id: 4,
    value: "acc-4",
    heading: "매칭에서 계약까지 얼마나 걸리나요?",
    detail: <Typography>기업에서 요청하신 커리어와 스킬에 따라 다르지만 보통 1주 ~ 2주 정도 걸립니다.</Typography>
  },
]);

// ----------------------------------------------------------------------

export default function FAQ() {
  const theme = useTheme();
  const accordions = ACCORDIONS(theme) || [];

  return (
    <Paper sx={{ my: 6 }}>
      <Typography variant="h6">
        자주 묻는 질문
      </Typography>
      <Box sx={{ py: 2 }}>
        {accordions.map((accordion, _) => (
          <Accordion sx={{ py: 1 }} key={accordion.value}>
            <AccordionSummary
              expandIcon={<Iconify icon={'eva:arrow-ios-downward-fill'} width={20} height={20} />}
            >
              <Typography variant="subtitle1">{accordion.heading}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {accordion.detail}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Paper>
  );
};
